/* eslint react/no-danger: 'off' */
/* global translations */
import React from 'react';
import get from 'lodash/get';

const VerificationFooter = () => (
  <div className="mtl tss">
    <div
      dangerouslySetInnerHTML={{ __html: get(translations, 'txt: Lai vairāk uzzinātu, kā mēs izmantojam, glabājam un aizsargājam Tavus datus, iepazīsties ar portāla Privātuma Politiku', '') }}
    />
    <div className="mtm tsi">
      {get(translations, 'txt: Ja vēlies atsaukt verificētā profila nozīmi, lūdzam sazināties ar administrāciju info@otrapuse.lv', '')}
    </div>
  </div>
);

export default VerificationFooter;
